






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Label extends Vue {
  @Prop({ required: true })
  name: string;

  get convertedName() {
    return (
      this.name
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, str => {
          return str.toUpperCase();
        })
    );
  }
}
